import { IonSkeletonText } from "@ionic/react";
import { SwiperSlide } from "swiper/react";

import BasicCard from "@components/cards/BasicCard";
import styles from "@components/loaders/LoaderStyles.module.css";
import Slides from "@components/Slides";

const GoalTemplatesLoader = () => {
  /* eslint-disable @typescript-eslint/naming-convention */
  const breakPoints = {
    1300: {
      slidesPerView: 3
    },
    1301: {
      slidesPerView: 4
    },
    600: {
      slidesPerView: 1
    },
    767: {
      slidesPerView: 2
    },
    950: {
      slidesPerView: 3
    }
  };
  /* eslint-enable @typescript-eslint/naming-convention */

  return (
    <div>
      {Array.from(Array(2)).map(() => (
        <div key={Math.random()}>
          <div>
            <IonSkeletonText animated className={styles.skeletonSectionTitle} />
          </div>
          <Slides breakpoints={breakPoints} spaceBetween={20}>
            {Array.from(Array(4)).map(() => (
              <SwiperSlide key={Math.random()}>
                <BasicCard hover="none">
                  <div className={styles.skeletonCard}>
                    <div className={styles.skeletonMargin}>
                      <IonSkeletonText animated className={styles.skeletonTag} />
                    </div>
                    <div className={styles.skeletonSmallMargin}>
                      <IonSkeletonText animated className={styles.skeletonTitle} />
                    </div>
                    <div>
                      <IonSkeletonText animated className={styles.skeletonBlurb} />
                    </div>
                  </div>
                </BasicCard>
              </SwiperSlide>
            ))}
          </Slides>
        </div>
      ))}
    </div>
  );
};

export default GoalTemplatesLoader;
